export const WarningSvg2 = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.1665 12.8333H23.8332V16.5H20.1665V12.8333ZM20.1665 20.1667H23.8332V31.1667H20.1665V20.1667ZM21.9998 3.66667C11.8798 3.66667 3.6665 11.88 3.6665 22C3.6665 32.12 11.8798 40.3333 21.9998 40.3333C32.1198 40.3333 40.3332 32.12 40.3332 22C40.3332 11.88 32.1198 3.66667 21.9998 3.66667ZM21.9998 36.6667C13.9148 36.6667 7.33317 30.085 7.33317 22C7.33317 13.915 13.9148 7.33334 21.9998 7.33334C30.0848 7.33334 36.6665 13.915 36.6665 22C36.6665 30.085 30.0848 36.6667 21.9998 36.6667Z"
                fill="#FFC43D"/>
        </svg>

    )
}

export const Back = () => {
    return (
        <svg fill="#FFA927" version="1.1" baseProfile="tiny" id="Layer_1"
             width="800px" height="800px" viewBox="0 0 42 42">
<g id="SVGRepo_bgCarrier" strokeWidth="0"/>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
            <g id="SVGRepo_iconCarrier"> <polygon fillRule="evenodd"
                                                  points="31,38.32 13.391,21 31,3.68 28.279,1 8,21.01 28.279,41 "/> </g>
</svg>

    )
}

export const BackSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="none">
            <path d="M11.8125 1.375L1.1875 12L11.8125 22.625" stroke="black" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export const ArrowRightButtonSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="23" viewBox="0 0 13 23" fill="none">
            <path d="M1 22.25L11.625 11.625L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const ArrowLeftButtonSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="23" viewBox="0 0 13 23" fill="none">
            <path d="M11.625 1L1 11.625L11.625 22.25" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export const Back2Icon = () => {
    return (
        <svg fill="#FFC43D" version="1.1" baseProfile="tiny" id="Layer_1"
             width="204px" height="204px" viewBox="0 0 42 42" stroke="#FFC43D" strokeWidth="4.2">

<g id="SVGRepo_bgCarrier" strokeWidth="0"/>

            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC"
               strokeWidth="0.08399999999999999"/>

            <g id="SVGRepo_iconCarrier"> <polygon fillRule="evenodd"
                                                  points="31,38.32 13.391,21 31,3.68 28.279,1 8,21.01 28.279,41 "/> </g>

</svg>
    )
}

export const ClickMeArrow = () =>{
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M8.60112 16.5308C8.89426 16.8234 9.36913 16.823 9.66178 16.5299C9.95442 16.2367 9.95402 15.7619 9.66088 15.4692L8.60112 16.5308ZM5.52988 11.3452C5.23674 11.0526 4.76187 11.053 4.46922 11.3461C4.17658 11.6393 4.17698 12.1141 4.47012 12.4068L5.52988 11.3452ZM4.48682 11.3291C4.18475 11.6125 4.16964 12.0871 4.45306 12.3892C4.73648 12.6912 5.21111 12.7064 5.51318 12.4229L4.48682 11.3291ZM9.64418 8.54694C9.94625 8.26352 9.96136 7.78889 9.67794 7.48682C9.39452 7.18475 8.91989 7.16964 8.61782 7.45306L9.64418 8.54694ZM5 11.126C4.58579 11.126 4.25 11.4618 4.25 11.876C4.25 12.2902 4.58579 12.626 5 12.626V11.126ZM15.37 11.876L15.3723 11.126H15.37V11.876ZM17.9326 10.8234L18.4614 11.3553V11.3553L17.9326 10.8234ZM19.75 8.26907C19.7511 7.85486 19.4163 7.51815 19.0021 7.517C18.5879 7.51586 18.2511 7.85072 18.25 8.26493L19.75 8.26907ZM9.66088 15.4692L5.52988 11.3452L4.47012 12.4068L8.60112 16.5308L9.66088 15.4692ZM5.51318 12.4229L9.64418 8.54694L8.61782 7.45306L4.48682 11.3291L5.51318 12.4229ZM5 12.626H15.37V11.126H5V12.626ZM15.3677 12.626C16.5267 12.6295 17.6395 12.1724 18.4614 11.3553L17.4038 10.2916C16.8641 10.8282 16.1333 11.1283 15.3723 11.126L15.3677 12.626ZM18.4614 11.3553C19.2833 10.5382 19.7468 9.42801 19.75 8.26907L18.25 8.26493C18.2479 9.02598 17.9435 9.755 17.4038 10.2916L18.4614 11.3553Z"
                    fill="#FFA927"></path>
            </g>
        </svg>
    )
}
